module.exports = __webpack_public_path__ + "img/talk.e083620.png";